export default import.meta.ROLLUP_FILE_URL_gTxdgYqT1FnWrjfbk9DrbA;